import { DatePipe } from "@angular/common";
import { Component, Injector, Input, OnInit } from "@angular/core";
import { AppRouterService } from "src/app/services/app-router.service";
import { AppSettingService } from "src/app/services/app-setting.service";
import * as echarts from "echarts";

import "../../../assets/scripts/echarts/map/js/china.js";
import { SimpleChanges } from "@angular/core";
import * as jQuery from "jquery";
@Component({
  selector: "app-index-page",
  templateUrl: "./index-page.component.html",
  styleUrls: ["./index-page.component.less"],
  providers: [DatePipe],
})
export class IndexPageComponent implements OnInit {
  //主标题图片路径
  public mainTitleUrl: string = "";
  //时间管道
  protected datePipe: DatePipe;
  //配置服务
  protected appSettingService: AppSettingService;
  //路由服务
  protected routerService: AppRouterService;
  //Echarts配置数组
  @Input() chartOptions: Array<any> = [];
  //EchartDiv
  public charts: Array<{ id: string }> = [];
  //MapOption
  public mapOption: any = {};
  public date: string;
  public time: string;
  public weekDay: string;
  public menus: Array<any> = [];
  constructor(private injector: Injector) {
    this.datePipe = this.injector.get(DatePipe);
    this.appSettingService = this.injector.get(AppSettingService);
    this.routerService = this.injector.get(AppRouterService);;
  }

  ngOnInit(): void {
    //获取菜单配置
    this.menus = this.appSettingService.getMenu();
  }

 
}
